import TRANSMISSION from "../../../components/shared/images/transmission.png";
import ABS from "../../../components/shared/images/abs.png";
import CHECK_ENGINE from "../../../components/shared/images/check-engine.png";
import SRS from "../../../components/shared/images/srs.png";

import LIGHT from "../../../components/shared/images/light.png";
import TYRE from "../../../components/shared/images/tyre.png";
import EXTERIOR from "../../../components/shared/images/exterior.png";
import SEAT from "../../../components/shared/images/seat.png";
import KEYS from "../../../components/shared/images/keys.png";
import SERVICE_HISTORY from "../../../components/shared/images/service-history.png";
import PRE_CONDITIONS from "../../../components/shared/images/preconditions.png";
import WING_MIRROR from "../../../components/shared/images/wing-mirror.png";
// Used for Destop Pre-BI Flow
const QUESTIONNAIRE_CONFIG = {
    "lastStep": 14,
    "totalSteps": 14,
    "selectCar": {
        "initialStep": "page1",
        "page1": {
            "heading": "Car Information",
            "currentStep": "page1",
            "currentStepNo": 1,
            "nextButtonGaEventLabel": "variant_screen",
            "backButtonGaEventLabel": "variant_screen",
            "amplitudeEvent": "variant and odometer answered",
            "nextStep": "'carCondition'",
            "isNextBtnDisabled": "!(typeof self.odometerReading === 'number' && typeof self.state === 'string')",
            "showCarInformation": false,
            "previousStep": "'delivery-details'",
            "group": "selectCar",
            "questions": [
                {
                    "key": "tradeInServiceProviderId",
                    "componentType": "VariantList",
                    "isVisible": true,
                    "isOptional": false,
                    "extraComponentVisible": false
                },
                {
                    "key": "odometerReading",
                    "isVisible": true,
                    "questionText": "What is the current <span>odometer reading</span> of the car?",
                    "componentType": "InputNumber",
                    "maxLength": 10,
                    "className": "col-6",
                    "placeholder": "Odometer reading",
                    "gaEventKey": "ODOMETER_READING",
                    "amplitudeEvent": "ODOMETER_READING",
                    "amplitudePropertyKey": "odometer",
                    "gaEventLabel": "'NA'",
                    "options": null,
                    "isOptional": false,
                    "extraComponentVisible": false,
                    "extraComponent": {},
                    "validator": true
                },
                {
                    "key": "state",
                    "isVisible": "self.makeModelFlow",
                    "questionText": "Which state is your <span>car registered in</span>?",
                    "componentType": "Select",
                    "errorMessage": "",
                    "placeholder": "Select State",
                    "gaEventKey": "",
                    "amplitudeEvent": "STATE_ENTERED",
                    "amplitudePropertyKey": "state",
                    "gaEventLabel": "'NA'",
                    "options": [
                        {
                            "label": "Victoria",
                            "value": "Victoria"
                        },
                        {
                            "label": "New South Wales",
                            "value": "New South Wales"
                        },
                        {
                            "label": "Queensland",
                            "value": "Queensland"
                        },
                        {
                            "label": "South Australia",
                            "value": "South Australia"
                        },
                        {
                            "label": "Australian Capital Territory",
                            "value": "Australian Capital Territory"
                        },
                        {
                            "label": "Western Australia",
                            "value": "Western Australia"
                        },
                        {
                            "label": "Tasmania",
                            "value": "Tasmania"
                        },
                        {
                            "label": "Northern Territory",
                            "value": "Northern Territory"
                        }
                    ],
                    "isOptional": false,
                    "extraComponentVisible": false,
                    "extraComponent": {}
                }
            ],
            "sorryScreen": {
                "show": true,
                "key": "noTradeIn",
                "modalType": "self.owner === false ? 'registration' : self.odometerReading > 140000 ?  'odometer' : null ",
                "screen": "variant_screen"
            }

        }
    },
    "preConditions": {
        "initialStep": "page2",
        "page2": {
            "heading": "",
            "currentStep": "page2",
            "currentStepNo": 2,
            "nextButtonGaEventLabel": "pre_conditions_screen",
            "backButtonGaEventLabel": "pre_conditions_screen",
            "amplitudeEvent": "precondition questions answered",
            "nextStep": ({isCarHavingCorrosionOrRust}) => isCarHavingCorrosionOrRust ? "sorryScreen" : "page3",
            "isNextBtnDisabled": "!(typeof self.serviceHistoryStatus === 'string' &&  typeof self.noOfKeys === 'number' && typeof self.isCarHavingCorrosionOrRust === 'boolean')",
            "showCarInformation": true,
            "previousStep": "'selectCar'",
            "group": "estimatedValuation",
            "questions": [
                {
                    "key": "serviceHistoryStatus",
                    "isVisible": true,
                    "questionText": "Tell us about the <span>service history</span> of your car.",
                    "image": SERVICE_HISTORY,
                    "componentType": "TabOption",
                    "className": "col-4",
                    "gaEventKey": "SERVICE_HISTORY_MOBILE",
                    "amplitudeEvent": "SERVICE_HISTORY_ENTERED",
                    "amplitudePropertyKey": "status of service history",
                    "gaEventLabel": "(self.serviceHistoryStatus)",
                    "options": [{
                        "label": "Full",
                        "value": "full"
                    }, {
                        "label": "Partial",
                        "value": "partial"
                    }, {
                        "label": "None",
                        "value": "none"
                    }],
                    "isOptional": false,
                    "extraComponentVisible": "(typeof self.serviceHistoryStatus === 'string' && self.noOfServiceHistory > 1)",
                    "extraComponent": {
                        "key": "serviceHistoryStatus",
                        "isVisible": "(typeof self.serviceHistoryStatus === 'string' && self.noOfServiceHistory > 1 )",
                        "questionText": "",
                        "componentType": "info",
                        "hideImg": true,
                        "label": {
                            "full": "from an authorised workshop with stamps on the log book.",
                            "partial": "from an authorised workshop with stamps on the log book. The number of services will affect your final valuation."
                        },
                        "options": null,
                        "isOptional": false
                    }
                },
                {
                    "key": "noOfKeys",
                    "isVisible": true,
                    "questionText": "How many <span>keys</span> are functional?",
                    "image": KEYS,
                    "componentType": "TabOption",
                    "className": "col-4",
                    "gaEventKey": "NUMBER_OF_KEYS_MOBILE",
                    "gaEventLabel": "(self.noOfKeys === 1 ? 'one' : (self.noOfKeys === 2 ? 'two' : 'three'))",
                    "amplitudeEvent": "NUMBER_OF_KEYS_ENTERED",
                    "amplitudePropertyKey": "keys",
                    "options": [{
                        "label": "1 Key",
                        "value": 1
                    }, {
                        "label": "2 Keys",
                        "value": 2
                    },
                    {
                        "label": "3 Keys",
                        "value": 3
                    }],
                    "isOptional": false,
                    "extraComponentVisible": false,
                    "extraComponent": {}
                },
                {
                    "key": "isCarHavingCorrosionOrRust",
                    "isVisible": true,
                    "questionText": "Does your car have <span>underbody rust or corrosion?</span>",
                    "questionClassName": "grow1",
                    "componentType": "TabOption",
                    "className": "col-6",
                    "gaEventKey": "IS_CAR_HAVING_CORROSION_OR_RUST_MOBILE",
                    "gaEventLabel": "(self.isCarHavingCorrosionOrRust === true ? 'yes' : 'no')",
                    "amplitudeEvent": "IS_CAR_HAVING_CORROSION_OR_RUST_MOBILE_ENTERED",
                    "amplitudePropertyKey": "isCarHavingCorrosionOrRust",
                    "options": [{
                        "label": "Yes",
                        "value": true
                    }, {
                        "label": "No",
                        "value": false
                    }],
                    "isOptional": false,
                    "extraComponentVisible": false,
                    "extraComponent": {}
                }
            ],
            "sorryScreen": {
                "show": true,
                "modalType": "havingIssue",
                "screen": "screener_questions"
            }
        },
        "page3": {
            "heading": "",
            "currentStep": "page3",
            "currentStepNo": 3,
            "nextButtonGaEventLabel": "pre_conditions_screen",
            "backButtonGaEventLabel": "pre_conditions_screen",
            "amplitudeEvent": "precondition questions answered",
            "nextStep": ({isCarHavingAnIssue, hideEstimatedScreen, majorAccidentHappened}) => {
                if (isCarHavingAnIssue || majorAccidentHappened) {
                    return "sorryScreen";
                } else if (hideEstimatedScreen) {
                    return "exterior-condition";
                } else {
                    return "estimated-valuation";
                }
            },
            "isNextBtnDisabled": "!(typeof self.isCarHavingAnIssue === 'boolean' && typeof self.majorAccidentHappened === 'boolean')",
            "showCarInformation": true,
            "previousStep": "'page2'",
            "group": "estimatedValuation",
            "questions": [
                {
                    "key": "isCarHavingAnIssue",
                    "isVisible": true,
                    "questionText": "Does your car have any of the following issues?",
                    "image": PRE_CONDITIONS,
                    "listPoints": [
                        "Written off or stolen as per PPSR",
                        "Does not drive or needs towing"
                    ],
                    "componentType": "TabOption",
                    "className": "col-6",
                    "gaEventKey": "HARD_GAURDRAIL_ANSWERED",
                    "gaEventLabel": "(self.isCarHavingAnIssue ? 'yes' :  'no')",
                    "amplitudeEvent": "HARD_GAURDRAIL_ANSWERED",
                    "amplitudePropertyKey": "guardrail status",
                    "options": [{
                        "label": "Yes",
                        "value": true
                    }, {
                        "label": "No",
                        "value": false
                    }],
                    "isOptional": false,
                    "extraComponentVisible": false,
                    "extraComponent": {}
                },
                {
                    "key": "majorAccidentHappened",
                    "isVisible": true,
                    "questionText": "Has your car ever been in a <span>major accident</span> (estimated costs of more than $3000)?",
                    "questionClassName": "grow1",
                    "componentType": "TabOption",
                    "className": "col-6",
                    "gaEventKey": "MAJOR_ACCIDENT_HAPPENED_ANSWERED",
                    "gaEventLabel": "(self.majorAccidentHappened ? 'yes' :  'no')",
                    "amplitudeEvent": "MAJOR_ACCIDENT_HAPPENED_ANSWERED",
                    "amplitudePropertyKey": "majorAccidentHappened",
                    "options": [{
                        "label": "Yes",
                        "value": true
                    }, {
                        "label": "No",
                        "value": false
                    }],
                    "isOptional": false,
                    "extraComponentVisible": false,
                    "extraComponent": {}
                }
            ],
            "sorryScreen": {
                "show": true,
                "modalType": "havingIssue",
                "screen": "screener_questions"
            }
        }
    },
    "estimatedValuation": {
        "initialStep": "page4",
        "page4": {
            "heading": "",
            "currentStep": "page4",
            "currentStepNo": 4,
            "amplitudeEvent": "price range accepted",
            "nextButtonGaEventLabel": "estimated_valuation_screen",
            "backButtonGaEventLabel": "estimated_valuation_screen",
            "nextStep": "'exterior-condition'",
            "previousStep": "'pre-conditions'",
            "questions": []
        }
    },
    "exteriorCondition": {
        "initialStep": "page5",
        "page5": {
            "heading": "",
            "currentStep": "page5",
            "currentStepNo": 5,
            "nextButtonGaEventLabel": "exterior_damage_selection_screen",
            "backButtonGaEventLabel": "exterior_damage_selection_screen",
            "amplitudeEvent": "exterior parts condition clicked",
            "amplitudeKey": "parts status",
            "amplitudeValue": "self.havingExteriorImperfection ? 'imperfections' : 'good'",
            "nextStep": ({havingExteriorImperfection}) => havingExteriorImperfection ? "page6" : "page7",
            "isNextBtnDisabled": "!(typeof self.havingExteriorImperfection === 'boolean')",
            "showCarInformation": true,
            "previousStep": ({hideEstimatedScreen}) =>  hideEstimatedScreen ? "pre-conditions" : "estimated-valuation",
            "questions": [{
                "key": "havingExteriorImperfection",
                "isVisible": true,
                "questionText": "Tell us about the condition of your <span> car’s exterior </span>",
                "description": "Select any one option",
                "image": EXTERIOR,
                "gaEventKey": "EXTERIOR_DAMAGE",
                "gaEventLabel": "self.havingExteriorImperfection",
                "componentType": "TabOptionV2",
                "options": [{
                    "label": "All parts are in good condition",
                    "description": "(no visible dents/ scratches/ scuffs/ chips on the panels and windscreens of the car)",
                    "value": false,
                    "isDamagedOption": false
                }, {
                    "label": "Some parts have imperfections ",
                    "description": "(visible dents/ scratches/ scuffs/ chips on the panels or windscreens of the car)",
                    "value": true,
                    "isDamagedOption": true
                }],
                "isOptional": false,
                "extraComponentVisible": "self.damageType === 'Other'",
                "extraComponent": { }
            }],
            "sorryScreen": {
                "show": true,
                "modalType": "condition",
                "screen": "exterior_damage"
            }
        },
        "page6": {
            "heading": "",
            "currentStep": "page6",
            "currentStepNo": 6,
            "nextStep": () => "page7",
            "nextButtonGaEventLabel": "exterior_damage_parts_screen",
            "backButtonGaEventLabel": "exterior_damage_parts_screen",
            "isNextBtnDisabled": "!(Object.values(self.majorExteriorDamage).includes(true) || Object.values(self.minorExteriorDamage).includes(true) )",
            "previousStep": () => "page5",
            "showCarInformation": true,
            "showConfimationPopup": true,
            "questions": [{
                "isVisible": true,
                "questionText": "",
                "componentType": "exteriorDamage",
                "gaEventKey": "INTERIOR_DAMAGE",
                "gaEventLabel": "self.isHavingLightImperfection"
            }]
        },
        "page7": {
            "heading": "",
            "currentStep": "page7",
            "currentStepNo": 7,
            "nextButtonGaEventLabel": "lights_wingmirrors_damage_screen",
            "backButtonGaEventLabel": "lights_wingmirrors_damage_screen",
            "amplitudeEvent": "lights and wing mirrors answered",
            "amplitudeKey": "lights status",
            "amplitudeValue": "self.isHavingLightImperfection ? 'imperfections' : 'good condition'",
            "amplitudeSecondaryKey": "mirrors status",
            "amplitudeSecondaryValue": "self.mirrorDamage",
            "nextStep": () => "page8",
            "isNextBtnDisabled": "!(typeof self.isHavingLightImperfection === 'boolean'  && ( (self.isHavingLightImperfection && self.lightDamage  && (self.lightDamage.driver_head_light || self.lightDamage.passenger_head_light || self.lightDamage.passenger_tail_light || self.lightDamage.driver_tail_light) ) || !self.isHavingLightImperfection) )",
            "showCarInformation": true,
            "previousStep": ({havingExteriorImperfection}) => havingExteriorImperfection ? "page6" : "page5",
            "questions": [{
                "key": "isHavingLightImperfection",
                "subKey": "lightDamage",
                "isVisible": true,
                "questionText": "Tell us about the <span>headlight and taillight</span> condition",
                "description": "Select any one option",
                "image": LIGHT,
                "componentType": "isHavingLightImperfection",
                "gaEventKey": "INTERIOR_DAMAGE",
                "gaEventLabel": "self.isHavingLightImperfection",
                "options": [{
                    "label": "All lights are in good condition",
                    "description": "(No scratches, cracks or moisture in the lights)",
                    "value": false,
                    "isDamagedOption": false
                }, {
                    "label": "Some lights have imperfections",
                    "description": "(scratches/ broken/ cloudy or some moisture in the lights)",
                    "value": true,
                    "isDamagedOption": true,
                    "options": [{
                        "label": "Headlight driver side",
                        "key": "driver_head_light"
                    }, {
                        "label": "Headlight passenger side",
                        "key": "passenger_head_light"
                    }, {
                        "label": "Taillight passenger side",
                        "key": "passenger_tail_light"
                    },
                    {
                        "label": "Taillight driver side",
                        "key": "driver_tail_light"
                    }]
                }],
                "isOptional": false,
                "extraComponentVisible": false,
                "extraComponent": {}
            }],
            "sorryScreen": {
                "show": true,
                "modalType": "condition",
                "screen": "interior_damage"
            }
        },
        "page8": {
            "heading": "",
            "currentStep": "page8",
            "currentStepNo": 8,
            "nextButtonGaEventLabel": "wingmirrors_damage_screen",
            "backButtonGaEventLabel": "wingmirrors_damage_screen",
            "amplitudeEvent": "wing mirrors answered",
            "amplitudeKey": "mirrors status",
            "amplitudeValue": "self.mirrorDamage",
            "nextStep": () => "page9",
            "isNextBtnDisabled": "!(typeof self.mirrorDamage === 'string')",
            "showCarInformation": true,
            "previousStep": () => "page7",
            "questions": [{
                "key": "mirrorDamage",
                "isVisible": true,
                "questionText": "Tell us about the <span>wing mirror</span> condition",
                "image": WING_MIRROR,
                "description": "Select any one option",
                "componentType": "TabOptionV2",
                "gaEventKey": "NUMBER_OF_KEYS_MOBILE",
                "gaEventLabel": "(self.mirrorDamage)",
                "amplitudeEvent": "NUMBER_OF_KEYS_ENTERED",
                "amplitudePropertyKey": "keys",
                "options": [{
                    "label": "Both wing mirrors are in good condition",
                    "description": "No scratches/ cracks in the mirrors",
                    "value": "none",
                    "isDamagedOption": false
                }, {
                    "label": "One wing mirror has imperfection",
                    "description": "Broken or cracked mirror",
                    "value": "one",
                    "isDamagedOption": true
                },
                {
                    "label": "Both wing mirrors have imperfection",
                    "description": "Broken or cracked mirrors",
                    "value": "both",
                    "isDamagedOption": true
                }],
                "isOptional": false,
                "extraComponentVisible": false,
                "extraComponent": {}
            }],
            "sorryScreen": {
                "show": true,
                "modalType": "condition",
                "screen": "exterior_damage"
            }
        },
        "page9": {
            "heading": "",
            "currentStep": "page9",
            "currentStepNo": 9,
            "nextButtonGaEventLabel": "tyres_and_wheels_damage_screen",
            "backButtonGaEventLabel": "tyres_and_wheels_damage_screen",
            "amplitudeEvent": "tyres and wheels answered",
            "amplitudeKey": "tyres and wheels answered status",
            "amplitudeValue": "self.tyreAndWheelsDamage",
            "nextStep": () => "mechanical-condition",
            "isNextBtnDisabled": "!(typeof self.tyreAndWheelsDamage === 'object' && self.tyreAndWheelsDamage && (self.tyreAndWheelsDamage.is_tyre_damaged || self.tyreAndWheelsDamage.is_wheel_damaged || self.tyreAndWheelsDamage.none)  && (self.tyreAndWheelsDamage.wheel_major_count + self.tyreAndWheelsDamage.wheel_minor_count <= 5) && ( (self.tyreAndWheelsDamage.is_wheel_damaged && (self.tyreAndWheelsDamage.wheel_major_count + self.tyreAndWheelsDamage.wheel_minor_count > 0)) || !self.tyreAndWheelsDamage.is_wheel_damaged) )",
            "showCarInformation": true,
            "previousStep": () => "page8",
            "questions": [{
                "key": "tyreAndWheelsDamage",
                "isVisible": true,
                "questionText": "Tell us about the <span>car tyres and wheels</span> condition",
                "image": TYRE,
                "description": "Select all that apply",
                "componentType": "tyreAndWheels",
                "gaEventKey": "INTERIOR_DAMAGE",
                "gaEventLabel": "self.tyreAndWheelsDamage",
                "options": [{
                    "label": "All tyres and wheels are in good condition ",
                    "description": "(Including spare)",
                    "key": "none",
                    "deSelectKey": "all",
                    "expandable": false,
                    "isDamagedOption": false
                }, {
                    "label": "At least one tyre is worn out or missing",
                    "description": "4+ yrs or >40,000 KMs driven on current tyres",
                    "key": "is_tyre_damaged",
                    "showTyre": true,
                    "showWheel": false,
                    "deSelectKey": "none",
                    "expandable": true,
                    "isDamagedOption": true
                }, {
                    "label": "At least one wheel is damaged",
                    "description": "(scuffs/ scratches/ scrapes/ bends/ cracks on wheel)",
                    "key": "is_wheel_damaged",
                    "showTyre": false,
                    "showWheel": true,
                    "deSelectKey": "none",
                    "expandable": true,
                    "isDamagedOption": true
                }],
                "isOptional": false,
                "extraComponentVisible": false,
                "extraComponent": {}
            }],
            "sorryScreen": {
                "show": true,
                "modalType": "condition",
                "screen": "exterior_damage"
            }
        }
    },
    "mechanicalCondition": {
        "initialStep": "page10",
        "page10": {
            "heading": "",
            "currentStep": "page10",
            "currentStepNo": 10,
            "nextButtonGaEventLabel": "warning_lights",
            "backButtonGaEventLabel": "warning_lights",
            "amplitudeEvent": "dashboard warning answered",
            "amplitudeKey": "dashboard warning status",
            "amplitudeValue": "self.dashboardWarning",
            "nextStep": "(self.dashboardWarning.engine_light || self.dashboardWarning.transmission_light) ? 'sorryScreen' : 'page11'",
            "isNextBtnDisabled": "((self.dashboardWarning === null || typeof self.dashboardWarning === 'undefined') || (self.dashboardWarning && !self.dashboardWarning.engine_light && !self.dashboardWarning.srs_light && !self.dashboardWarning.abs_light && !self.dashboardWarning.transmission_light && !self.dashboardWarning.none))",
            "showCarInformation": true,
            "previousStep": "'exterior-condition'",
            "questions": [{
                "key": "dashboardWarning",
                "isVisible": true,
                "questionText": "Tell us about the status of your <span>dashboard warning lights</span>",
                "description": "Select all that apply",
                "gaEventKey": "DASHBOARD_WARNING_LIGHTS",
                "gaEventLabel": "self.dashboardWarning",
                "componentType": "ListTabMultiple",
                "options": [{
                    "label": "No dashboard warning lights on",
                    "key": "none",
                    "deSelectKey": "all"
                }, {
                    "label": "Check Engine light",
                    "key": "engine_light",
                    "deSelectKey": "none",
                    "image": CHECK_ENGINE
                }, {
                    "label": "Airbag or SRS light",
                    "key": "srs_light",
                    "deSelectKey": "none",
                    "image": SRS
                }, {
                    "label": "ABS light",
                    "key": "abs_light",
                    "deSelectKey": "none",
                    "image": ABS
                },
                {
                    "label": "Transmission warning light",
                    "key": "transmission_light",
                    "deSelectKey": "none",
                    "image": TRANSMISSION
                }],
                "isOptional": false,
                "extraComponentVisible": false,
                "extraComponent": { }
            }],
            "sorryScreen": {
                "show": true,
                "modalType": "havingIssue",
                "screen": "screener_questions"
            }
        },
        "page11": {
            "heading": "",
            "currentStep": "page11",
            "currentStepNo": 11,
            "nextButtonGaEventLabel": ({engineTransSuspensionExperiment}) => `mechanical_condition_clicked_${engineTransSuspensionExperiment}`,
            "backButtonGaEventLabel": "mechanical condition proceed",
            "amplitudeEvent": "mechanical condition proceed",
            "amplitudeKey": "variant",
            "amplitudeValue": "self.engineTransSuspensionExperiment",
            "amplitudeSecondaryKey": "option",
            "amplitudeSecondaryValue": "self.engineTransSuspensionRating",
            "nextStep": "((self.engineTransSuspensionRating < 3.5 && (self.dashboardWarning.srs_light || self.dashboardWarning.abs_light)) || self.engineTransOrSusMaintOccurred === 'yes_outside_warranty') ? 'sorryScreen': 'interior-condition'",
            "isNextBtnDisabled": "(typeof self.engineTransSuspensionRating !== 'number' || (self.engineTransSuspensionExperiment === 'VARIANT_A' && self.engineTransSuspensionRating === 3) || typeof self.engineTransOrSusMaintOccurred !== 'string')",
            "showCarInformation": true,
            "previousStep": "'page10'",
            "questions": [{
                "key": "engineTransSuspensionRating",
                "isVisible": true,
                "questionText": "How would you rate your car’s <span>mechanical condition</span> on a scale of 1 to 5?",
                "questionClassName": "grow1",
                "description": "Consider 1 as the worst and 5 as the best rating. This includes issues with the engine, transmission, and suspension of the car.",
                "componentType": "Slider",
                "experimentBased": {
                    experimentName: "c2bMechanicalCondition",
                    variant: "VARIANT_B"
                },
                extraParams: {
                    engineTransSuspensionExperiment: "VARIANT_B"
                },
                gaDataOnload: () => ({
                    "eventName": "MECHANICAL_CONDITION_RATING_VIEWED",
                    eventLabel: "flow_pre-bi_VARIANT_B"
                }),
                amplitudeDataOnload: () => ({
                    amplitudeEvent: "MECHANICAL_CONDITION_RATING_VIEWED",
                    properties: {
                        "flow": "pre_bi",
                        "Variant": "VARIANT_B"
                    }
                }),
                "sliderProps": {
                    // eslint-disable-next-line no-magic-numbers
                    domain: [1, 5],
                    mode: 1,
                    tickCount: 9,
                    railColor: "#B0BEF9",
                    // eslint-disable-next-line no-magic-numbers
                    defaultValues: [3],
                    disabledTrackStyles: {
                        background: "#0033FF"
                    },
                    hideTicksOnEdges: false,
                    step: 0.50,
                    sliderWrapperStyle: {width: "100%", marginTop: "28px", marginBottom: "24px"},
                    handleColor: "blue",
                    trackStyle: {height: "12px"},
                    trackSliderInnerStyle: {height: "12px"},
                    tickStyle: {marginTop: "10px", height: "6px"},
                    handleStyle: {width: "28px", height: "28px", outline: "#5577FF solid 1px", background: "#5577FF", borderWidth: "5px", boxShadow: "1px 1px 4px 0px #9DA5C5"},
                    tickTextStyle: {marginTop: "20px"},
                    ticksWrapperStyle: {position: "relative", padding: "0 5px"},
                    mainDivisorHeight: "10px",
                    showTickText: (value) => value === Math.floor(value)
                },
                "isOptional": false,
                "extraComponentVisible": false,
                "extraComponent": { }
            },
            {
                "key": "engineTransSuspensionRating",
                "isVisible": true,
                "questionText": "How would you describe your car’s <span>mechanical condition?</span>",
                "questionClassName": "grow1",
                "description": "Including issues with the engine, transmission or suspension.",
                "componentType": "TabOptionV2",
                "experimentBased": {
                    experimentName: "c2bMechanicalCondition",
                    variant: "VARIANT_A"
                },
                extraParams: {
                    engineTransSuspensionExperiment: "VARIANT_A"
                },
                gaDataOnload: () => ({
                    eventName: "MECHANICAL_CONDITION_RATING_VIEWED",
                    eventLabel: "flow_pre-bi_VARIANT_A"
                }),
                amplitudeDataOnload: () => ({
                    amplitudeEvent: "MECHANICAL_CONDITION_RATING_VIEWED",
                    properties: {
                        "flow": "pre_bi",
                        "Variant": "VARIANT_A"
                    }
                }),
                "options": [{
                    "label": "Good",
                    "description": "Never had any issues.",
                    "value": 5,
                    "isDamagedOption": false
                }, {
                    "label": "Fair",
                    "description": "Faced issues once or twice in a year.",
                    "value": 3.5
                },
                {
                    "label": "Poor",
                    "description": "Faced issues more than twice in a year.",
                    "value": 3.1,
                    "isDamagedOption": true
                }],
                "isOptional": false,
                "extraComponentVisible": false,
                "extraComponent": { }
            },
            {
                "key": "engineTransOrSusMaintOccurred",
                "isVisible": true,
                "questionText": "Has your <span>car’s engine, transmission or suspension</span> ever been replaced, repaired or modified?",
                "questionClassName": "grow1",
                "gaEventKey": "ENGINE_TANSMISSION_OR_SUSPENSION_MAINTENANCE_OCCURRED",
                "gaEventLabel": "self.engineTransOrSusMaintOccurred",
                "componentType": "TabOption",
                "className": "col-12",
                "options": [{
                    "label": "No – Never replaced, repaired, or modified",
                    "value": "no"
                }, {
                    "label": "Yes – Repair/replacement is under warranty",
                    "value": "yes_within_warranty"
                }, {
                    "label": "Yes – Repair/replacement is without warranty",
                    "value": "yes_outside_warranty"
                }
                ],
                "isOptional": false,
                "extraComponentVisible": false,
                "extraComponent": { }
            }
            ],
            "sorryScreen": {
                "show": true,
                "modalType": "havingIssue",
                "screen": "screener_questions"
            }
        }
    },
    "interiorCondition": {
        "initialStep": "page12",
        "page12": {
            "heading": "",
            "currentStep": "page12",
            "currentStepNo": 12,
            "isSeatsQuestion": true,
            "nextButtonGaEventLabel": "seats_headrest_damage_screen",
            "backButtonGaEventLabel": "seats_headrest_damage_screen",
            "amplitudeEvent": "seats and headrest answered",
            "amplitudeKey": "seats and headrest status",
            "amplitudeValue": "self.isSeatHavingImperfection ? 'imperfections' : 'good condition'",
            "nextStep": "'page13'",
            "isNextBtnDisabled": "!(typeof self.isSeatHavingImperfection === 'boolean')",
            "showCarInformation": true,
            "previousStep": "'mechanical-condition'",
            "questions": [{
                "key": "isSeatHavingImperfection",
                "isVisible": true,
                "questionText": "Tell us about the <span>car's seats and headrests</span> condition",
                "description": "Select any one option",
                "image": SEAT,
                "componentType": "TabOptionV2",
                "gaEventKey": "NUMBER_OF_KEYS_MOBILE",
                "gaEventLabel": "(self.isSeatHavingImperfection)",
                "options": [{
                    "label": "All seats and headrests are in good condition",
                    "description": "(no tears, stains, holes, burns, peelings or missing headrests)",
                    "value": false,
                    "isDamagedOption": false
                }, {
                    "label": "Some seats have wear and tear or missing headrests",
                    "description": "(tears, stains, holes, burns, peelings or missing headrests)",
                    "value": true,
                    "isDamagedOption": true
                }],
                "isOptional": false,
                "extraComponentVisible": false,
                "extraComponent": {}
            }],
            "sorryScreen": {
                "show": true,
                "modalType": "condition",
                "screen": "interior_damage"
            }
        },
        "page13": {
            "heading": "",
            "currentStep": "page13",
            "currentStepNo": 13,
            "nextButtonGaEventLabel": "electronic_damage_screen",
            "backButtonGaEventLabel": "electronic_damage_screen",
            "amplitudeEvent": "electronic component answered",
            "amplitudeKey": "electronic component status",
            "amplitudeValue": "self.electronicDamage",
            "nextStep": "'page14'",
            "isNextBtnDisabled": "((self.electronicDamage === null || typeof self.electronicDamage === 'undefined') || (self.electronicDamage && !self.electronicDamage.touch_screen && !self.electronicDamage.satellite_gps && !self.electronicDamage.radio_infotainment && !self.electronicDamage.air_conditioner && !self.electronicDamage.none))",
            "showCarInformation": true,
            "previousStep": "'page12'",
            "questions": [{
                "key": "electronicDamage",
                "isVisible": true,
                "questionText": "Tell us about the <span>electronic components</span> of your car",
                "description": "Select all that apply",
                "componentType": "ListTabMultiple",
                "gaEventKey": "ELECTRONIC_DAMAGE",
                "gaEventLabel": "self.electronicDamage",
                "options": [{
                    "label": "Touch screen in central console is broken or not working",
                    "key": "touch_screen",
                    "deSelectKey": "none"
                }, {
                    "label": "Satellite navigation / GPS is not functional",
                    "key": "satellite_gps",
                    "deSelectKey": "none"
                }, {
                    "label": "Radio / infotainment system does not work",
                    "key": "radio_infotainment",
                    "deSelectKey": "none"
                }, {
                    "label": "AC doesn't blow cold air or does not work",
                    "key": "air_conditioner",
                    "deSelectKey": "none"
                },
                {
                    "label": "All in good condition",
                    "key": "none",
                    "deSelectKey": "all"
                }],
                "isOptional": false,
                "extraComponentVisible": false,
                "extraComponent": { }
            }],
            "sorryScreen": {
                "show": true,
                "modalType": "condition",
                "screen": "exterior_damage"
            }
        },
        "page14": {
            "heading": "",
            "currentStep": "page14",
            "currentStepNo": 14,
            "nextButtonGaEventLabel": "interior_damage_screen",
            "backButtonGaEventLabel": "interior_damage_screen",
            "amplitudeEvent": "interior component answered",
            "amplitudeKey": "interior component status",
            "amplitudeValue": "self.interiorDamage",
            "nextStep": "'trade-in-consent'",
            "isNextBtnDisabled": "((self.interiorDamage === null || typeof self.interiorDamage === 'undefined') || (self.interiorDamage && !self.interiorDamage.steering_wheel && !self.interiorDamage.sunroof && !self.interiorDamage.rear_view_mirror && !self.interiorDamage.none && !self.interiorDamage.cargo_barrier))",
            "showCarInformation": true,
            "previousStep": "'page13'",
            "questions": [{
                "key": "interiorDamage",
                "isVisible": true,
                "questionText": "Tell us about the <span>interior condition</span> of your car",
                "description": "Select all that apply",
                "componentType": "ListTabMultiple",
                "gaEventKey": "INTERIOR_DAMAGE",
                "gaEventLabel": "self.interiorDamage",
                "options": [{
                    "label": "Steering wheel has been worn out or deformed",
                    "description": "",
                    "key": "steering_wheel",
                    "deSelectKey": "none"
                }, {
                    "label": "Sunroof is broken or not functioning properly",
                    "description": "",
                    "key": "sunroof",
                    "deSelectKey": "none"
                }, {
                    "label": "Rear view mirror is broken or missing",
                    "description": "",
                    "key": "rear_view_mirror",
                    "deSelectKey": "none"
                }, {
                    "label": "Cargo barrier is missing or in poor condition",
                    "description": "",
                    "key": "cargo_barrier",
                    "deSelectKey": "none"
                },
                {
                    "label": "All in good condition",
                    "key": "none",
                    "deSelectKey": "all"
                }],
                "isOptional": false,
                "extraComponentVisible": false,
                "extraComponent": {}
            }],
            "sorryScreen": {
                "show": true,
                "modalType": "condition",
                "screen": "interior_damage"
            }
        }
    }
};

export default QUESTIONNAIRE_CONFIG;
